import building from '@/store/modules/pto/building'
import object from '@/store/modules/pto/object'
import project from '@/store/modules/pto/project/index.js'
import changelog from '@/store/modules/pto/changelog'
import handbook from '@/store/modules/pto/handbook'

export default {
  namespaced: true,
  modules: {
    building,
    object,
    project,
    changelog,
    handbook
  }
}
